export const getAsset = (asset: string) => {
  return `https://cdn.treedis.com/assets/${asset}`;
};
